import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import NavbarCustom from "../../Components/NavbarCustom";
import SEO from "../../Components/SEO";

const PrivacyPolicy = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <SEO
        title="Privacy Policy - Shootin School Inc"
        description="Privacy Policy and SMS Messaging Compliance"
        url="https://shootinschool.com/privacy-policy"
      />

      <NavbarCustom />
      <StaticPageHeaders title="Privacy Policy" />

      <div className="privacy-container brightness">
        <div className="privacy-inside">
          <p className="text-clip">
            <strong>Shootin School Inc</strong>
            <br />
            <strong>Effective Date: Jan 1st, {currentYear}</strong>
          </p>

          <h2 className="text-clip">
            IMPORTANT NOTICE REGARDING TEXT MESSAGING DATA
          </h2>
          <p className="text-clip">
            Shootin School Inc ("we," "us," or "our") does <strong>not</strong>{" "}
            share customer opt-in information, including phone numbers and
            consent records, with affiliates or third parties for marketing or
            promotional purposes. All SMS opt-in data is kept strictly
            confidential.
          </p>

          <h2 className="text-clip">1. Information We Collect</h2>

          <h3 className="text-clip">Personal Information</h3>
          <ul className="text-clip">
            <li>Name, email address, phone number, physical address</li>
            <li>
              Payment information when making a purchase or requesting a quote
            </li>
            <li>
              Opt-in records and timestamps for SMS, email, and other
              communications
            </li>
          </ul>

          <h3 className="text-clip">Non-Personal Information</h3>
          <ul className="text-clip">
            <li>IP address, browser type, device information</li>
            <li>Website usage patterns and analytics</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>

          <h3 className="text-clip">Customer Communication</h3>
          <ul className="text-clip">
            <li>Inquiry and support records</li>
            <li>Appointment details and preferences</li>
            <li>Service history and feedback</li>
          </ul>

          <h2 className="text-clip">2. How We Use Your Information</h2>
          <ul className="text-clip">
            <li>Provide and improve our services</li>
            <li>Process payments and transactions</li>
            <li>Send service-related messages and updates</li>
            <li>Enhance website performance and security</li>
            <li>Maintain consent and communication preferences</li>
          </ul>

          <h2 className="text-clip">3. SMS Messaging & Compliance</h2>

          <h3 className="text-clip">Opt-In & Consent</h3>
          <ul className="text-clip">
            <li>Messages are sent only after explicit opt-in</li>
            <li>Timestamped consent records are maintained</li>
            <li>We comply with the Telephone Consumer Protection Act (TCPA)</li>
          </ul>

          <h3 className="text-clip">Opt-Out Instructions</h3>
          <ul className="text-clip">
            <li>
              Reply <strong>STOP</strong> to cancel SMS messages at any time
            </li>
            <li>You will receive a confirmation message</li>
            <li>No further messages will be sent unless you re-opt in</li>
          </ul>

          <h3 className="text-clip">Message Frequency & Content</h3>
          <ul className="text-clip">
            <li>Message frequency varies</li>
            <li>Messages relate only to requested services</li>
            <li>No promotional messages without explicit consent</li>
          </ul>

          <h3 className="text-clip">Help & Support</h3>
          <ul className="text-clip">
            <li>
              Reply <strong>HELP</strong> for assistance
            </li>
            <li>Contact us at shootinschool@gmail.com</li>
          </ul>

          <h3 className="text-clip">Carrier Information</h3>
          <ul className="text-clip">
            <li>Standard message & data rates may apply</li>
            <li>Carriers are not liable for delayed or undelivered messages</li>
            <li>Supported carriers include major U.S. providers</li>
          </ul>

          <p className="text-clip">
            <strong>SMS Data Protection Statement:</strong>
            <br />
            No mobile information will be shared with third parties/affiliates
            for marketing/promotional purposes. Information sharing to
            subcontractors in support services, such as customer service is
            permitted. All other use case categories exclude text messaging
            originator opt-in data and consent; this information will not be
            shared with any third parties.
          </p>

          <h2 className="text-clip">4. Information Sharing & Disclosure</h2>
          <p className="text-clip">
            We do not sell, rent, or trade personal information.
          </p>

          <h3 className="text-clip">Service Providers</h3>
          <ul className="text-clip">
            <li>Payment processors and scheduling platforms</li>
            <li>SMS providers solely for message delivery</li>
            <li>
              All providers are contractually obligated to protect your data
            </li>
          </ul>

          <h3 className="text-clip">Legal Compliance</h3>
          <ul className="text-clip">
            <li>When required by law or legal process</li>
            <li>To protect our rights and safety</li>
          </ul>

          <h2 className="text-clip">5. Data Security</h2>
          <ul className="text-clip">
            <li>Encrypted data transmission</li>
            <li>Restricted system access</li>
            <li>Routine security reviews</li>
            <li>Employee data protection training</li>
          </ul>

          <p className="text-clip">
            While we use commercially reasonable protections, no system is 100%
            secure.
          </p>

          <h2 className="text-clip">6. Cookies & Tracking Technologies</h2>
          <p className="text-clip">
            We use cookies to analyze traffic, remember preferences, and improve
            site functionality. You can manage cookies through your browser
            settings.
          </p>

          <h2 className="text-clip">7. Your Rights & Choices</h2>
          <ul className="text-clip">
            <li>Access, update, or delete your personal information</li>
            <li>Unsubscribe from marketing emails</li>
            <li>Opt out of SMS by replying STOP</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <h2 className="text-clip">8. Third-Party Links</h2>
          <p className="text-clip">
            Our website may contain links to third-party sites. We are not
            responsible for their privacy practices.
          </p>

          <h2 className="text-clip">9. Changes to This Privacy Policy</h2>
          <p className="text-clip">
            Updates will be posted on this page with a revised effective date.
          </p>

          <h2 className="text-clip">10. Contact Us</h2>
          <p className="text-clip">
            <strong>Shootin School Inc</strong>
            <br />
            Phone: 1-347-212-0028
            <br />
            Email:{" "}
            <a href="mailto:shootinschool@gmail.com">
              <span className="text-clip">shootinschool@gmail.com</span>
            </a>
            <br />
            Website:{" "}
            <Link to="/">
              <span className="text-clip">https://shootinschool.com</span>
            </Link>
          </p>

          <p className="text-clip">
            By using our website and services, you consent to this Privacy
            Policy.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
